module.exports={author:"Xandria Phillips",date:"04/16/2021",publishDate:"04/16/2021",highlighted:!1,tags:"",title:"Ars Cinema"};